import { suggestVehicleClassification } from './classificationSuggestions';
import { renderTypeOf } from './renderRegistry';

const classOf = (layout) => layout?.vehicle_class || {};

const layoutGroupsOf = (layouts = []) => {
  const groups = new Map();

  layouts.forEach((layout) => {
    const vehicleClass = classOf(layout);
    if (!vehicleClass.code) return;
    if (!groups.has(vehicleClass.code)) {
      const cataloguedClass = renderTypeOf(vehicleClass.code);
      groups.set(vehicleClass.code, {
        key: vehicleClass.code,
        name: cataloguedClass?.label || vehicleClass.name || vehicleClass.code,
        silhouette: vehicleClass.silhouette || vehicleClass.render_model_key || vehicleClass.code,
        layouts: [],
      });
    }
    groups.get(vehicleClass.code).layouts.push(layout);
  });

  return [...groups.values()].map((group) => ({
    ...group,
    layouts: [...group.layouts].sort((left, right) => (
      Number(left.wheel_count) - Number(right.wheel_count)
      || Number(left.version) - Number(right.version)
      || String(left.name).localeCompare(String(right.name))
    )),
  }));
};

const classKeyForVehicle = (vehicle, layouts = []) => (
  vehicle?.active_layout?.vehicle_class?.code
  || suggestVehicleClassification(vehicle, layouts)?.classKey
  || null
);

const commonClassKeyOf = (vehicles = [], layouts = []) => {
  if (!vehicles.length) return null;
  const keys = vehicles.map((vehicle) => classKeyForVehicle(vehicle, layouts));
  if (keys.some((key) => !key)) return null;
  return new Set(keys).size === 1 ? keys[0] : null;
};

const confirmedClassKeysOf = (vehicles = []) => new Set(
  vehicles
    .map((vehicle) => vehicle?.active_layout?.vehicle_class?.code)
    .filter(Boolean),
);

const hasMixedConfirmedClasses = (vehicles = []) => (
  vehicles.length > 1 && confirmedClassKeysOf(vehicles).size > 1
);

export {
  classKeyForVehicle,
  commonClassKeyOf,
  confirmedClassKeysOf,
  hasMixedConfirmedClasses,
  layoutGroupsOf,
};
